import { Box, Grid, Typography, useTheme, useMediaQuery } from "@mui/material";

const HomeReason = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        py: { xs: 4, md: 10 },
        px: { xs: 2, sm: 4, md: 12 },
        backgroundColor: "#f8fafc",
      }}
    >
      <Grid container spacing={6} alignItems="center">
        {/* TEXT COLUMN */}
        <Grid item size={{ xs: 12, sm: 12, md: 6 }}>
          <Box>
            <Typography
              variant="h3"
              component="h4"
              sx={{
                fontSize: { xs: "1.2rem", sm: "2rem", md: "2rem" },
                fontWeight: 700,
                letterSpacing: "-0.025em",
                color: "#0F172A",
                lineHeight: 1.2,
              }}
            >
              Building a Fairer Food Chain
            </Typography>

            <Box sx={{ textAlign: "start" }}>
              <Typography
                variant="body1"
                sx={{ mt: 3, color: "#334155", maxWidth: "90%" }}
              >
                At Tuberway, we believe the best food stories start from the
                ground.
              </Typography>

              <Typography sx={{ color: "#334155" }}>
                We work directly with local farmers to grow, process, and
                distribute high-quality yams and root crops, ensuring freshness
                for our local customers and reliability for our global partners.
              </Typography>

              <Typography sx={{ color: "#334155" }}>
                Whether you’re buying for your kitchen or importing for your
                continent, Tuberway stands for one promise: honest food, fairly
                traded.
              </Typography>
            </Box>
          </Box>
        </Grid>

        {/* IMAGE COLUMN */}
        <Grid item size={{ xs: 12, sm: 12, md: 6 }}>
          <Box
            sx={{
              borderRadius: 3,
              overflow: "hidden",
              width: "100%",
              aspectRatio: isMobile ? "4/3" : "16/9",
              boxShadow: 3,
            }}
          >
            <img
              src="marketMan.jpg"
              alt="yamTruck"
              loading="lazy"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default HomeReason;
